/* HZ 2026-09-14: moved out of snippets/hz-ugc-carousel.liquid into this deferred asset file.
   Same code; it used to be inlined into every page (and, for the quick-add,
   once per product card) and blocked HTML parsing while it evaluated. */
(function() {
  /* Colorway re-sort: the velour parents carry every colorway on one page, so the
     server-side order only fixes page load. Re-order on swatch change too.
     NOTE: Dawn renders the radio name with a trailing newline, hence .trim(). */
  (function () {
    var sec = document.querySelector('.hz-ugc__track');
    if (!sec) return;
    var KNOWN = ['black stitch', 'red stitch', 'white stitch'];
    function resort(want) {
      var slides = Array.prototype.slice.call(sec.querySelectorAll('.hz-ugc__slide'));
      if (!slides.length) return;
      slides.map(function (el, i) {
        var cw = (el.getAttribute('data-hz-cw') || '').toLowerCase();
        var r = cw === want ? 0 : (cw ? 2 : 1);
        return { el: el, i: i, r: r };
      }).sort(function (a, b) {
        return a.r - b.r || a.i - b.i;
      }).forEach(function (o) { sec.appendChild(o.el); });
      sec.scrollLeft = 0;
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name || String(t.name).trim().toLowerCase().indexOf('color') === -1) return;
      var v = String(t.value || '').toLowerCase();
      for (var i = 0; i < KNOWN.length; i++) {
        if (v.indexOf(KNOWN[i]) !== -1) { resort(KNOWN[i]); return; }
      }
    }, true);
  })();

  var carousel = document.querySelector('.hz-ugc');
  if (!carousel || carousel.dataset.hzInit) return;
  carousel.dataset.hzInit = '1';

  var track = carousel.querySelector('.hz-ugc__track');
  var slides = carousel.querySelectorAll('.hz-ugc__slide');
  var prevBtn = carousel.querySelector('.hz-ugc__nav--prev');
  var nextBtn = carousel.querySelector('.hz-ugc__nav--next');
  var dots = carousel.querySelectorAll('.hz-ugc__dot');

  if (!track || slides.length === 0) return;

  function checkNavVisibility() {
    var isDesktop = window.innerWidth > 749;
    var overflows = track.scrollWidth > track.clientWidth + 5;
    if (isDesktop && overflows) {
      prevBtn.style.display = 'flex';
      nextBtn.style.display = 'flex';
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }
  }

  var imgCount = slides.length;
  var loadedCount = 0;
  function onAllLoaded() {
    checkNavVisibility();
    var overflows = track.scrollWidth > track.clientWidth + 5;
    if (!overflows) {
      track.classList.add('hz-ugc__track--centered');
    } else {
      track.classList.remove('hz-ugc__track--centered');
    }
  }
  slides.forEach(function(slide) {
    var img = slide.querySelector('img');
    if (img) {
      if (img.complete) { loadedCount++; }
      else { img.addEventListener('load', function() { loadedCount++; if (loadedCount >= imgCount) onAllLoaded(); }); }
    }
  });
  onAllLoaded();
  window.addEventListener('resize', onAllLoaded);

  function getSlideWidth() {
    return slides[0].offsetWidth + 12;
  }

  prevBtn.addEventListener('click', function() {
    track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function() {
    track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
  });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var idx = parseInt(dot.dataset.index, 10);
      idx = Math.min(idx, slides.length - 1);
      var target = slides[idx];
      if (target) {
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    });
  });

  var scrollTimeout;
  track.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      var scrollLeft = track.scrollLeft;
      var slideW = getSlideWidth();
      var activeIdx = Math.round(scrollLeft / slideW);
      activeIdx = Math.max(0, Math.min(activeIdx, slides.length - 1));

      /* Map slide index to page dot */
      var pageIdx = Math.min(Math.floor(activeIdx / 4), dots.length - 1);
      dots.forEach(function(d, i) {
        var isActive = i === pageIdx;
        d.classList.toggle('hz-ugc__dot--active', isActive);
        d.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      prevBtn.disabled = scrollLeft <= 5;
      nextBtn.disabled = scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    }, 80);
  });

  carousel.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') { prevBtn.click(); e.preventDefault(); }
    if (e.key === 'ArrowRight') { nextBtn.click(); e.preventDefault(); }
  });

  prevBtn.disabled = true;
})();
